module.exports = __webpack_public_path__ + "img/lookbook_1_center.327f6369.png";